import type { MaybeSettled, ReviewsSummaryProductInsights } from 'src/redux/reviews/types';

/**
 * Below this many responses the percentage is too easily swung by a single
 * vote to be worth showing, so the row is hidden instead. The data layer
 * (DISC-4325) deliberately stores the raw score and leaves this rule here.
 */
const MINIMUM_RESPONSES = 10;

/**
 * The whole percentage to render, or `null` when there is nothing worth
 * showing: the insights request has not settled, settled with nothing, or
 * settled with too few responses to be meaningful.
 */
export const getAsAdvertisedPercentage = (
  productInsights: MaybeSettled<ReviewsSummaryProductInsights>,
): number | null => {
  const asAdvertised = productInsights?.scores.wasTheProductAsAdvertised;

  if (!asAdvertised || asAdvertised.totalResponses < MINIMUM_RESPONSES) {
    return null;
  }

  return Math.round(asAdvertised.score * 100);
};
